import noReferences from './noReferences.js'

/**
 * Legacy alias over the generic `noReferences` guard.
 *
 *   condition: { type: 'collection', collection: 'document', filter: { field: 'folderId', value: 'id' } }
 *
 * Prefer `noReferences` for new guards — it adds `match`, `where`, `ignore` and a
 * COUNT fast path. This wrapper keeps existing configs working unchanged.
 */
const emptyCollection = async (target, condition, data, getData) =>
    noReferences(target, { ...condition, type: 'collection' }, data, getData)

export default emptyCollection
